<script lang="ts">
	import IconLabel from '$lib/components/atoms/iconlabel/IconLabel.svelte';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import ObfuscatedLink from '$lib/components/atoms/obfuscatedLink/ObfuscatedLink.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { isMobile } from '$lib/services/mediaQuery/screenSize';
	import * as m from '$paraglide/messages';
	import Card from '../routeSelector/components/CardTemplate.svelte';

	const { panelScrollPosition } = getMapLayoutContext();
	export interface ImageParams {
		src: string;
		alt: string;
		srcset: string;
	}

	interface Props {
		onclick?: (event: MouseEvent) => void;
		images: ImageParams[];
		href: string;
	}

	const { onclick, images, href }: Props = $props();

	let element: HTMLElement;
</script>
<Card class="rounded-sm! bg-hotel-minimal! !border-0 !shadow-none md:w-70 p-3!">
	<div bind:this={element}></div>
	{@const animate = $panelScrollPosition > 0 && -$panelScrollPosition < ($isMobile ? globalThis.innerHeight * 0.01 / 2 : globalThis.innerHeight / 2) - (element?.offsetTop ?? 0)}
	<ObfuscatedLink
		tag="div"
		{href}
		target="_blank"
		rel="noopener"
		{onclick}
		class="w-full"
	>
		<p class="flex items-center justify-center gap-1 m-0">
			<IconLabel
				label={m.route_zoi_hotel__title()}
				icon="hotel"
				iconClasses="bg-hotel-michelin text-neutral-weakest size-4! rd-50%! flex items-center justify-center"
				labelClasses="text-hotel-michelin"
				iconInsideClasses="w-3! h-3!"
			/>
		</p>

		<div class="group relative w-48 h-48 flex justify-center items-center mx-auto cursor-pointer">
			<span
				class="absolute z-20 px-2.75 py-2.5 bg-white text-gray-800 rounded-md shadow-md
					opacity-0 transition-opacity duration-300
					absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2
					cursor-pointer text-sm whitespace-nowrap flex items-center gap-1
					{animate ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}"
			>
				{m.route_zoi_hotel__cta_label()}
				<Icon tag="span" icon="open-in-new" class="text-gray-800 text-sm" />
			</span>

			{#each [...images].reverse() as image, index (image.src)}
				{@render renderImage(images.length - index, image, animate)}
			{/each}
		</div>
	</ObfuscatedLink>
</Card>
{#snippet renderImage(position: number, imageParams: { src: string; alt: string; srcset: string }, animate: boolean)}
	{@const top = position === 1 ? 'top-[25px]' : position === 2 ? 'top-[32px]' : 'top-[30px]'}
	{@const rotate = position === 1 ? '' : position === 2 ? 'rotate-2' : 'rotate--4'}
	{@const translateX = position === 1 ? '' : position === 2 ? 'translate-x-2' : 'translate-x--2'}
	{@const transitionClasses
		= position === 1
			? animate ? 'translate-y--5.75 rotate--2' : 'group-hover:translate-y--5.75 group-hover:rotate--2'
			: position === 2
			? animate ? 'rotate-4 translate-x-6 translate-y-1.5' : 'group-hover:rotate-4 group-hover:translate-x-6 group-hover:translate-y-1.5'
			: animate ? 'rotate--6 translate-x--6 translate-y-4' : 'group-hover:rotate--6 group-hover:translate-x--6 group-hover:translate-y-4'}

	<Image class="absolute w-[180px] h-[140px] rounded-xl shadow-md
		transition-all duration-200
		{top}
		{rotate}
		{translateX}
		{transitionClasses}
		border-2 border-hotel-weaker border-solid" alt={imageParams.alt} src={imageParams.src} srcset={imageParams.srcset} />
{/snippet}
